module.exports = __webpack_public_path__ + "img/img_default_thum_4.4fc452fa.png";